import { create } from 'zustand'

interface AuthState {
  isAuthenticated: boolean
  user: {
    name: string
    telegramId: string
    avatar: string
    country: string
    isAgent: boolean
    balance: number
  } | null
  login: (provider: string) => void
  logout: () => void
}

const mockUser = {
  name: '王大明',
  telegramId: '@daming_wang',
  avatar: '',
  country: 'TW',
  isAgent: true,
  balance: 125000, // $1,250.00 in cents
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  user: null,
  login: (_provider: string) => {
    set({ isAuthenticated: true, user: mockUser })
  },
  logout: () => {
    set({ isAuthenticated: false, user: null })
  },
}))
